import { apiUrl } from "../../utils/url";
import { HttpClient } from "../HttpClient";
import {
  CalculateProfileDTO,
  IRuleProfileService,
} from "./IRuleProfileService";

export class RuleProfileService implements IRuleProfileService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
    });
  }

  async calculateProfile(
    data: CalculateProfileDTO,
  ): Promise<{ profile: number }> {
    try {
      const { profile } = await this.httpClient.post<{ profile: number }>(
        "/ruleProfile/calculate",
        data,
      );
      return { profile };
    } catch (error) {
      throw new Error(
        "Não foi possível calcular o perfil do animal. Confirme os dados do animal e tente novamente.",
      );
    }
  }
}
